import { GetUserLocationWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('GetUserLocation')
export class GetUserLocationNodeSchemaProvider extends SchemaProvider<GetUserLocationWorkflowNode> {}
